/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Protocol used by the consumer to receive notifications.
 * @export
 */
export const ConsumerProtocol = {
    Webhook: 'WEBHOOK'
} as const;
export type ConsumerProtocol = typeof ConsumerProtocol[keyof typeof ConsumerProtocol];


export function instanceOfConsumerProtocol(value: any): boolean {
    for (const key in ConsumerProtocol) {
        if (Object.prototype.hasOwnProperty.call(ConsumerProtocol, key)) {
            if (ConsumerProtocol[key as keyof typeof ConsumerProtocol] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConsumerProtocolFromJSON(json: any): ConsumerProtocol {
    return ConsumerProtocolFromJSONTyped(json, false);
}

export function ConsumerProtocolFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerProtocol {
    return json as ConsumerProtocol;
}

export function ConsumerProtocolToJSON(value?: ConsumerProtocol | null): any {
    return value as any;
}

export function ConsumerProtocolToJSONTyped(value: any, ignoreDiscriminator: boolean): ConsumerProtocol {
    return value as ConsumerProtocol;
}

